/* eslint-disable import/prefer-default-export */
if (!process.env.NODE_ENV) {
  throw new Error('Variável de ambiente NODE_ENV não definida');
}

if (!process.env.ENVIRONMENT) {
  throw new Error('Variável de ambiente ENVIRONMENT não definida');
}

if (!process.env.PER_PAGE) {
  throw new Error('Variável de ambiente PER_PAGE não definida');
}

if (!process.env.BFF_URL) {
  throw new Error('Variável de ambiente BFF_URL não definida');
}

if (!process.env.FRETEBRAS_LOGOUT_URL) {
  throw new Error('Variável de ambiente FRETEBRAS_LOGOUT_URL não definida');
}

if (!process.env.URL_CEP_SERVICE) {
  throw new Error('Variável de ambiente URL_CEP_SERVICE não definida');
}

if (!process.env.YOUTUBE_VIDEO_ID_ONBOARDING) {
  throw new Error(
    'Variável de ambiente YOUTUBE_VIDEO_ID_ONBOARDING não definida',
  );
}

if (!process.env.NCA_MAP_URL) {
  throw new Error('Variável de ambiente NCA_MAP_URL não definida');
}

if (!process.env.NCA_JOURNEY_TIME_OF_CHECK_UPDATES) {
  throw new Error(
    'Variável de ambiente NCA_JOURNEY_TIME_OF_CHECK_UPDATES não definida',
  );
}

const {
  DATADOG_CLIENT_TOKEN,
  DATADOG_API_KEY,
  NODE_ENV,
  ENVIRONMENT,
  PER_PAGE,
  BFF_URL,
  FRETEBRAS_LOGOUT_URL,
  URL_CEP_SERVICE,
  YOUTUBE_VIDEO_ID_ONBOARDING,
  NCA_MAP_URL,
  NCA_JOURNEY_TIME_OF_CHECK_UPDATES,
} = process.env;

const WIDTH_MENU_HOST = '72px';

const CREATED_BY_OPTION_ONE = ['company:banking:credit', 'payment_identifier'];
const CREATED_BY_OPTION_TWO = [
  'company:nca:manually',
  'chat:negotiation:automatic',
  'gr:fretebras',
  'tms:fretebras',
  'tms:intersite',
  'trucker:deposit:fee',
];

const JOURNEY_STATUS_DONE = ['done', 'canceled', 'unrecognized'];
const DEEP_LINK_APP = 'https://www.fretebras.com.br/app';
const DEEP_LINK_APP_PROPOSAL = 'https://fretebras.onelink.me/Rtni/23m7zt6p';

export {
  DATADOG_CLIENT_TOKEN,
  DATADOG_API_KEY,
  NODE_ENV,
  ENVIRONMENT,
  PER_PAGE,
  BFF_URL,
  FRETEBRAS_LOGOUT_URL,
  URL_CEP_SERVICE,
  WIDTH_MENU_HOST,
  YOUTUBE_VIDEO_ID_ONBOARDING,
  NCA_MAP_URL,
  CREATED_BY_OPTION_ONE,
  CREATED_BY_OPTION_TWO,
  JOURNEY_STATUS_DONE,
  DEEP_LINK_APP,
  NCA_JOURNEY_TIME_OF_CHECK_UPDATES,
  DEEP_LINK_APP_PROPOSAL,
};
